export const SHARED_COMPONENTS_EN_US = {
  'sharedComponents.modal.confirm.confirmLabel': 'Confirm',
  'sharedComponents.modal.confirm.cancelLabel': 'Cancel',
  'sharedComponents.pagination.totalLabelIndeterminate': 'of many',
  'sharedComponents.pagination.totalLabel': 'of {total}',
  'sharedComponents.select.withConfirmation.cancel': 'Cancel',
  'sharedComponents.select.withConfirmation.apply': 'Apply',
  'sharedComponents.formField.optional': '(optional)',
  'sharedComponents.dateRangePicker.currentPeriod': 'Current Period',
  'sharedComponents.dateRangePicker.comparisonPeriod': 'Comparison Period',
  'sharedComponents.dateRangePicker.weekStartDay': 'Week Start Day',
} as const
